module.exports = __webpack_public_path__ + "img/UAE-landscape-english.6e36e8d9.jpg";